export const SINGLE_CHECKOUT_LOAD_TIME_TRACKING_DETAILS_STORAGE_KEY =
  'single_checkout_load_time_tracking_details'
